// extracted by mini-css-extract-plugin
export default {"container":"_5NxibWBrE8nWSUtyCNkbfv","firstItem":"l2O6H4qW3jHXkAOxjhOjL","secondItem":"_2ev3SAkWEjwsqBGzJ4AJxc","toggleLink":"_2nvOEbW1ZG1DuCuxczfl4t"};